module.exports = __webpack_public_path__ + "img/text-only.5f2062ab.svg";